<template>
  <div>
    <!-- nav -->
    <b-navbar type="dark" variant="primary">
      <b-navbar-brand>
        <b-button @click="$router.push('/dashboard')" variant="primary">
          <i class="fas fa-home"
        /></b-button>
        <a class="navbar-brand mr-5">Apex - PDV </a>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <PdvAccountSelectInput />
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <PdvSalesmanSelect />
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <!-- <nav class="navbar  navbar-expand-lg navbar-dark bg-primary">
     

      <a class="navbar-brand mr-5">Apex - PDV </a>

     class="d-flex" />
    </nav> -->
    <!-- nav -->
    <div class="mx-5  mt-4">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Echo from "laravel-echo";
import Pusher from "pusher-js";

import PdvAccountSelectInput from "@/components/pdv/sections/PdvAccountSelectInput";
import PdvSalesmanSelect from "@/components/pdv/sections/PdvSalesmanSelect";

export default {
  components: {
    PdvAccountSelectInput,
    PdvSalesmanSelect
  },

  data: function() {
    return {};
  },

  created() {},

  computed: {},

  methods: {}
};
</script>

<style lang="scss">
[v-cloak] {
  visibility: hidden;
  -webkit-font-smoothing: antialiased;
}
</style>
